import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import LangToggler from "./LangToggler";

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;

const Header = ({ imgPrefix, copy }) => (
  <StyledHeader>
    <img alt="logo" src={`${imgPrefix}/images/top_logo.png`} />
    <LangToggler {...{ copy }} />
  </StyledHeader>
);

Header.defaultProps = {};

Header.propTypes = {
  copy: PropTypes.objectOf(PropTypes.object).isRequired,
  imgPrefix: PropTypes.string.isRequired
};
export default Header;
